import React, { createContext, useCallback, useMemo, useState } from "react";

const STORAGE_KEY = "trafico_desktop_windows_v1";

const readStoredWindows = () => {
    try {
        const stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY));
        return Array.isArray(stored) ? stored : [];
    } catch {
        return [];
    }
};

export const WindowManagerContext = createContext({
    savedWindows: [],
    saveWindows: () => {},
    clearWindows: () => {},
});

export const WindowManagerProvider = ({ children }) => {
    const [savedWindows, setSavedWindows] = useState(readStoredWindows);

    const saveWindows = useCallback((windows) => {
        const serializableWindows = windows.map(({ id, type, title, contract, minimized, maximized, defaultSizeVersion, x, y, width, height }) => ({
            id,
            type,
            title,
            contract,
            minimized,
            maximized,
            defaultSizeVersion,
            x,
            y,
            width,
            height,
        }));
        const serializedWindows = JSON.stringify(serializableWindows);

        setSavedWindows((previousWindows) => {
            return JSON.stringify(previousWindows) === serializedWindows
                ? previousWindows
                : serializableWindows;
        });

        if (sessionStorage.getItem(STORAGE_KEY) !== serializedWindows) {
            sessionStorage.setItem(STORAGE_KEY, serializedWindows);
        }
    }, []);

    const clearWindows = useCallback(() => {
        setSavedWindows([]);
        sessionStorage.removeItem(STORAGE_KEY);
    }, []);

    const value = useMemo(() => ({ savedWindows, saveWindows, clearWindows }), [savedWindows, saveWindows, clearWindows]);

    return <WindowManagerContext.Provider value={value}>{children}</WindowManagerContext.Provider>;
};

export default WindowManagerContext;
